App.namespace.wrap('es6.shared.google_login_manager', function (options = {}) {
  const {
    buttonId,
    googleUrl,
    googleClientId,
    csrfToken,
    callback,
    prompt,
    autoLoginOnClick,
    trackingParams = {},
  } = options

  const GOOGLE_API_URL = 'https://accounts.google.com/gsi/client'
  const LOGIN_CONTAINER_ID = '#login-with-google-container'

  const api = {
    triggerModal() {
      $(LOGIN_CONTAINER_ID).find('[role="button"]').click();
    },
  }

  const sendAjaxRequest = (token) => {
    $.ajax({
      method: "POST",
      url: googleUrl,
      data: {
        idtoken: token,
        _token: csrfToken,
        trackingParams: typeof trackingParams === 'function' ? trackingParams() : trackingParams,
      },
      contentType: 'application/x-www-form-urlencoded',
      success: (response) => {
        if(typeof callback === 'function') {
          callback(response);
        } else if(typeof window[callback] === 'function') {
          window[callback](response);
        }
      },
      error: (err) => {
        if (typeof window[callback] === 'function') {
          window[callback](err);
          return;
        } else {
          alert('There was an error trying to login with Google, please try again');
        }

        Rollbar.critical('Failed google login attempt');
      }
    });
  }

  const handleCredentialResponse = (response) => {
    sendAjaxRequest(response.credential)
  }

  const bindBtnClick = () => {
    const loginNode = document.querySelector(LOGIN_CONTAINER_ID);
    window.google.accounts.id.initialize({
      client_id: googleClientId,
      ux_mode: 'popup',
      text: 'Log in with Google',
      callback: handleCredentialResponse,
    });

    window.google.accounts.id.renderButton(
      loginNode,
      {
        callback: handleCredentialResponse,
      },
    );

    if (autoLoginOnClick) {
      document.getElementById(buttonId).addEventListener('click', () => {
        api.triggerModal();
      });
    }

    if (prompt) {
      window.google.accounts.id.prompt();
    }
  };

  const waitForGoogleAPI = (initCallback) => {
    App.es6.shared.waitFor(() => {
      return window.google && window.google.accounts;
    }, error => {
      if (error) {
        window._GAPi_ERROR = 'Couldn\'t load google api.';
        initCallback();
        return;
      }
      bindBtnClick(initCallback);
    }, {attempts: 20});
  };

  const noop = () => null;
  const init = (initCallback = noop) => {
    $.getScript(GOOGLE_API_URL)
      .done(() => waitForGoogleAPI(initCallback));

    return api;
  };

  return {
    init
  }
});
